var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRetry = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42857 0C5.95094 0 4.53382 0.579463 3.48898 1.61091C2.44413 2.64236 1.85714 4.04131 1.85714 5.5H0L2.4081 7.87722L2.45143 7.96278L4.95238 5.5H3.09524C3.09524 4.36546 3.55178 3.27739 4.36444 2.47515C5.1771 1.67292 6.2793 1.22222 7.42857 1.22222C8.57784 1.22222 9.68004 1.67292 10.4927 2.47515C11.3054 3.27739 11.7619 4.36546 11.7619 5.5C11.7619 6.63454 11.3054 7.72261 10.4927 8.52485C9.68004 9.32708 8.57784 9.77778 7.42857 9.77778C6.23381 9.77778 5.15048 9.295 4.37048 8.51889L3.49143 9.38667C4.50048 10.3889 5.88095 11 7.42857 11C8.90621 11 10.3233 10.4205 11.3682 9.38909C12.413 8.35764 13 6.95869 13 5.5C13 4.04131 12.413 2.64236 11.3682 1.61091C10.3233 0.579463 8.90621 0 7.42857 0Z",
    fill: "#0029FF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRetry, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/retry.b674fd38.svg";
export { ForwardRef as ReactComponent };